export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Wareneingang',
      description: 'Ihre Produkte erreichen unsere Manufaktur und werden sorgfältig eingelagert.',
      icon: 'ri-truck-line'
    },
    {
      number: '02', 
      title: 'Bestelleingang',
      description: 'Sobald eine Bestellung eingeht, beginnt unser Verpackungsprozess.',
      icon: 'ri-notification-3-line'
    },
    {
      number: '03',
      title: 'Handverpackung',
      description: 'Jedes Produkt wird mit Liebe und Sorgfalt von Hand verpackt und kontrolliert.',
      icon: 'ri-hand-heart-line'
    },
    {
      number: '04',
      title: 'Versand',
      description: 'Das fertige Paket verlässt unsere Manufaktur und macht sich auf den Weg zum Kunden.',
      icon: 'ri-send-plane-line'
    }
  ];

  return (
    <section id="process" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            unser Verpackungs&shy;prozess
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Von der Ankunft Ihrer Produkte bis zum Versand an Ihre Kunden - 
            jeder Schritt wird mit traditioneller Handpackkunst und moderner Effizienz durchgeführt.
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gray-300 transform -translate-y-1/2"></div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative h-full">
                <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow text-center h-full flex flex-col">
                  {/* Step Number */}
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-12 h-12 text-white rounded-full flex items-center justify-center font-bold text-lg" style={{backgroundColor: '#B80E10'}}>
                    {step.number}
                  </div>
                  
                  {/* Icon */}
                  <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-6 mt-4">
                    <i className={`${step.icon} text-2xl text-black`}></i>
                  </div>
                  
                  <h3 className="text-xl font-bold text-black mb-4">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed flex-grow">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-gray-50 p-8 rounded-xl border border-gray-200">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-black mb-4">
                Warum handgepackt?
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                In einer Zeit der Automatisierung setzen wir bewusst auf die menschliche Note. 
                Unsere erfahrenen Mitarbeiter prüfen jedes Produkt, wählen die passende Verpackung 
                und sorgen dafür, dass Ihre Kunden ein besonderes Unboxing-Erlebnis haben.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-black mr-3"></i>
                  <span>Individuelle Qualitätskontrolle</span>
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-black mr-3"></i>
                  <span>Persönliche Verpackungsnotizen möglich</span>
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-black mr-3"></i>
                  <span>Nachhaltige Verpackungsmaterialien</span>
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-black mr-3"></i>
                  <span>Werktäglicher Versand</span>
                </li>
              </ul>
            </div>
            <div className="text-center">
              <img 
                src="https://readdy.ai/api/search-image?query=Hands%20carefully%20wrapping%20a%20package%20with%20brown%20paper%20and%20twine%2C%20black%20and%20white%20photography%2C%20monochrome%20traditional%20packaging%20materials%2C%20artisanal%20craftsmanship%20atmosphere%2C%20attention%20to%20detail%20in%20grayscale%2C%20vintage%20packaging%20style%20captured%20in%20black%20and%20white%2C%20sustainable%20materials%2C%20professional%20monochrome%20photography%2C%20dramatic%20lighting%20and%20shadows&width=500&height=400&seq=process-img-bw&orientation=landscape"
                alt="Handverpackung mit Liebe"
                className="rounded-lg shadow-lg mx-auto object-cover w-full h-64"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
